/* eslint-disable no-undef */
export var BotNodeId;
(function (BotNodeId) {
    BotNodeId["WHAT_HELP_WITH"] = "WHAT_HELP_WITH";
    BotNodeId["SELECT_PAYOUT"] = "SELECT_PAYOUT";
    BotNodeId["SELECT_ORDERS"] = "SELECT_ORDERS";
    BotNodeId["THAT_HELPED"] = "THAT_HELPED";
    BotNodeId["SELECT_SUPPORT_CHANNEL"] = "SELECT_SUPPORT_CHANNEL";
    BotNodeId["PAYOUT_NOT_PAID_CAPTURED_ORDERS"] = "PAYOUT_NOT_PAID_CAPTURED_ORDERS";
    BotNodeId["PAYOUT_WHEN_WILL_I_GET_PAID"] = "PAYOUT_WHEN_WILL_I_GET_PAID";
    BotNodeId["PAYOUT_PAID_WRONG_AMOUNT_CAPTURED_ORDERS"] = "PAYOUT_PAID_WRONG_AMOUNT_CAPTURED_ORDERS";
    BotNodeId["PAYOUT_CHANGE_PAYMENT_FREQUENCY"] = "PAYOUT_CHANGE_PAYMENT_FREQUENCY";
    BotNodeId["PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_UNABLE"] = "PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_UNABLE";
    BotNodeId["PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_ABLE"] = "PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_ABLE";
    BotNodeId["PAYOUT_NOT_PAID_IS_SCHEDULE_FOLLOWED"] = "PAYOUT_NOT_PAID_IS_SCHEDULE_FOLLOWED";
    BotNodeId["PAYOUT_PAID_WRONG_AMOUNT_IS_SCHEDULE_FOLLOWED"] = "PAYOUT_PAID_WRONG_AMOUNT_IS_SCHEDULE_FOLLOWED";
    BotNodeId["PAYOUT_NO_CAPTURED_ORDERS"] = "PAYOUT_NO_CAPTURED_ORDERS";
    BotNodeId["PAYOUT_IS_HOLDBACK_OR_DEBT"] = "PAYOUT_IS_HOLDBACK_OR_DEBT";
    BotNodeId["PAYOUT_SCHEDULE_FOLLOWED_EXPLANATION"] = "PAYOUT_SCHEDULE_FOLLOWED_EXPLANATION";
    BotNodeId["PAYOUT_NO_HOLDBACK"] = "PAYOUT_NO_HOLDBACK";
    BotNodeId["PAYOUT_WITH_HOLDBACK"] = "PAYOUT_WITH_HOLDBACK";
    BotNodeId["PAYOUT_FEES_RETURNS_HOLDBACKS_EXPLANATION"] = "PAYOUT_FEES_RETURNS_HOLDBACKS_EXPLANATION";
    BotNodeId["PAYOUT_PAID_WRONG_AMOUNT_SCHEDULE_FOLLOWED_EXPLANATION"] = "PAYOUT_PAID_WRONG_AMOUNT_SCHEDULE_FOLLOWED_EXPLANATION";
    BotNodeId["PAYOUT_WHEN_WILL_I_GET_PAID_CAPTURED_ORDERS"] = "PAYOUT_WHEN_WILL_I_GET_PAID_CAPTURED_ORDERS";
    BotNodeId["PAYOUT_WHEN_WILL_I_GET_PAID_SCHEDULE_FOLLOWED"] = "PAYOUT_WHEN_WILL_I_GET_PAID_SCHEDULE_FOLLOWED";
    BotNodeId["ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER"] = "ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER";
    BotNodeId["ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_YES"] = "ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_YES";
    BotNodeId["ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_NO"] = "ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_NO";
    BotNodeId["ORDERS_MISSED_CAPTURE_DEADLINE"] = "ORDERS_MISSED_CAPTURE_DEADLINE";
    BotNodeId["ORDERS_EXPIRATION_DATE_SURPASSED"] = "ORDERS_EXPIRATION_DATE_SURPASSED";
    BotNodeId["ORDERS_EXPIRATION_DATE_SURPASSED_CREDIT"] = "ORDERS_EXPIRATION_DATE_SURPASSED_CREDIT";
    BotNodeId["ORDERS_MISSED_CAPTURE_DEADLINE_NO"] = "ORDERS_MISSED_CAPTURE_DEADLINE_NO";
    BotNodeId["ORDERS_REFUND_AN_ORDER"] = "ORDERS_REFUND_AN_ORDER";
    BotNodeId["ORDERS_FULLY_CAPTURED_YES"] = "ORDERS_FULLY_CAPTURED_YES";
    BotNodeId["ORDERS_FULLY_CAPTURED_NO"] = "ORDERS_FULLY_CAPTURED_NO";
    BotNodeId["ORDERS_FULLY_CAPTURED_PARTIALLY"] = "ORDERS_FULLY_CAPTURED_PARTIALLY";
})(BotNodeId || (BotNodeId = {}));
export var UxEvent;
(function (UxEvent) {
    UxEvent["GO_TO_HELP_HOME"] = "GO_TO_HELP_HOME";
    UxEvent["GO_TO_CHANNEL_SELECTION"] = "GO_TO_CHANNEL_SELECTION";
})(UxEvent || (UxEvent = {}));
export var RequestMethodEnum;
(function (RequestMethodEnum) {
    RequestMethodEnum[RequestMethodEnum["GET"] = 0] = "GET";
    RequestMethodEnum[RequestMethodEnum["POST"] = 1] = "POST";
})(RequestMethodEnum || (RequestMethodEnum = {}));
export var RegionEnum;
(function (RegionEnum) {
    RegionEnum["EU"] = "eu";
    RegionEnum["US"] = "us";
    RegionEnum["AP"] = "ap";
})(RegionEnum || (RegionEnum = {}));
